<template>
  <div>
    <div style="display: none">
      <div id="report_holder"></div>
    </div>
    <el-row>
      <el-col :span="11">
        <el-row>
          <el-select
            v-model="whsettingTopId"
            placeholder="请选择"
            @change="selectWhsetting"
          >
            <el-option
              v-for="item in whsettingListTop"
              :key="item.Id + '_top'"
              :label="item.Name"
              v-model="item.Id"
            ></el-option>
          </el-select>
          <el-checkbox
            v-model="TarePrint"
            label="过磅并打印"
            border
            @change="changePrint"
          ></el-checkbox>
        </el-row>
        <el-row>
          <div class="number">{{ whnumber }}</div>
        </el-row>
        <el-row>
          <el-col :span="3" :offset="2">
            <el-button
              type="primary"
              @click.native="addGross"
              v-show="showType"
            >
              过毛
            </el-button>
          </el-col>
          <el-col :span="3" :offset="showType ? 0 : 9">
            <el-button type="primary" @click.native="addTare">过皮</el-button>
          </el-col>
          <el-col :span="3">
            <el-button
              type="primary"
              @click.native="saveForm()"
              :loading="editLoading"
              v-show="showType"
            >
              保存
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button
              v-show="showType && showPhotoBtn"
              type="primary"
              @click.native="getShot(0)"
              :loading="editLoading"
            >
              拍照
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click.native="cancel" v-show="showType">
              取消
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click.native="showTypeChange">
              {{ showType ? "只过皮" : "返回" }}
            </el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5"><h3>过磅信息</h3></el-col>
        </el-row>
        <el-row>
          <el-form
            :model="editForm"
            label-width="100px"
            :rules="editFormRules"
            ref="editForm"
            class="editForm"
            v-show="showType"
          >
            <!-- 从这里开始复制 -->
            <el-row>
              <el-col :span="12">
                <el-form-item label="过磅单号">
                  <el-input v-model="editForm.Code" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车号">
                  <template>
                    <el-select
                      v-model="editForm.VehicleErpCode"
                      filterable
                      remote
                      :remote-method="remoteMethod"
                      default-first-option
                      @change="changeLicense"
                      @click.native="remoteMethod('')"
                      placeholder="请选择单据"
                    >
                      <el-option
                        v-for="item in proOutMasterList"
                        :key="item.Id + '_carcode'"
                        :label="item.VehicleErpCode + '-' + item.License"
                        :value="item.Id"
                        style="height: 150px"
                      >
                        <div>
                          <span>
                            车号:{{ item.VehicleErpCode }} 车牌:{{
                              item.License
                            }}
                            方量{{ item.QuantityTotal }}
                          </span>
                          <br />
                          <span>
                            发货单号:{{ item.Code }} 任务:{{ item.TaskCode }}
                          </span>
                          <br />
                          <span>
                            工程:{{ item.ProjectName }} 强度:{{
                              item.GradeName
                            }}
                          </span>
                        </div>
                      </el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="毛重">
                  <el-input v-model="editForm.GrossWeight" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="任务单编号">
                  <el-input v-model="editForm.TaskCode" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="参考皮重">
                  <el-input v-model="editForm.TareWeight" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="皮重">
                  <el-input v-model="editForm.TareWeight" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="生产方量">
                  <el-input v-model="editForm.Quantity" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="出货单编号">
                  <el-input
                    v-model="editForm.ProdOutMasterCode"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="扣重">
                  <el-input
                    v-model="editForm.BuckleWeight"
                    @input="NetWeightCount"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发货累计">
                  {{ editForm.QuantityTotal }}方/{{ editForm.VehiclesTotal }}车
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="扣除率">
                  <el-input
                    v-model="editForm.DeductionRate"
                    @input="NetWeightCount"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="过磅累计">
                  {{
                    Number(editForm.TaskTotalQuantity) +
                    Number(editForm.WeighingQuantity)
                  }}方/{{ editForm.TaskTotalTruckCount }}车
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="净重">
                  <el-input v-model="editForm.NetWeight" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注">
                  <el-input v-model="editForm.Remark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="容重">
                  <el-input v-model="editForm.DiscountCubRate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="过磅方量">
                  <el-input v-model="editForm.WeighingQuantity"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col
                :v-if="shotGList.length > 0 ? true : false"
                :span="12"
                v-for="(item, i) in shotGList"
                :key="i + 'shotG'"
              >
                <img
                  :id="'shotG_' + i"
                  :src="item.FilePath"
                  style="width: 270px; height: 180px; border: 1px solid"
                />
              </el-col>
            </el-row>
            <el-row>
              <el-col
                :v-if="shotTList.length > 0 ? true : false"
                :span="12"
                v-for="(item, i) in shotTList"
                :key="i + 'shotT'"
              >
                <img
                  :id="'shotT_' + i"
                  :src="item.FilePath"
                  style="width: 270px; height: 180px; border: 1px solid"
                />
              </el-col>
            </el-row>
            <!-- 从这里结束 -->
          </el-form>
          <el-form
            :model="editVehicle"
            label-width="100px"
            ref="editVehicle"
            class="editForm"
            v-if="!showType"
          >
            <el-col :span="12">
              <el-form-item label="车重">
                <el-input v-model="editVehicle.CarWeight" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车号">
                <el-select
                  v-model="editVehicle.Id"
                  filterable
                  placeholder="请选择"
                  @change="selectVehicle"
                >
                  <el-option
                    v-for="item in VehicleList"
                    :key="item.Id + '_VL'"
                    :label="
                      item.ErpCode + '(' + item.License
                        ? item.License
                        : '' + ')'
                    "
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-row>
          <el-col
            :span="12"
            v-for="(item, i) in VideoUrlList"
            :key="i + 'video'"
          >
            <img
              :id="'video_' + i"
              style="width: 270px; height: 180px; border: 1px solid"
            />
          </el-col>
        </el-row>

        <el-form label-width="50px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="车号">
                <el-input
                  v-model="License"
                  width="100px"
                  @change="getWeighingOut(1)"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6" :offset="1">
              <el-form-item label="磅秤">
                <el-select
                  v-model="WeightID"
                  placeholder="请选择"
                  @change="getWeighingOut(1)"
                  :clearable="true"
                >
                  <el-option
                    v-for="item in whsettingListSelect"
                    :key="item.Id + '_bc'"
                    :label="item.Name"
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2" :offset="1">
              <el-button @click="getWeighingOut(1)">查询</el-button>
            </el-col>
          </el-row>
        </el-form>

        <el-row
          class="overflow-auto"
          :gutter="10"
          :style="VideoUrlList.length > 0 ? 'height: 55vh' : 'height: 75vh'"
        >
          <!--列表-->
          <el-table
            :data="WeighingOut"
            highlight-current-row
            v-loading="listLoading"
            style="width: 100%"
          >
            <el-table-column prop="Remark" label="磅单信息" width="300">
              <template slot-scope="scope">
                <div>
                  磅单号：
                  <span class="table-value">
                    {{ scope.row.Code }}
                  </span>
                </div>
                <div>
                  过磅方量：
                  <span class="table-value">
                    {{ scope.row.WeighingQuantity }}
                  </span>
                  容重：
                  <span class="table-value">
                    {{ scope.row.DiscountCubRate }}
                  </span>
                  发货方量：
                  <span class="table-value">{{ scope.row.Quantity }}</span>
                </div>
                <div>
                  车号：
                  <span class="table-value">
                    {{ scope.row.VehicleErpCode }}
                  </span>
                  车牌：
                  <span class="table-value">{{ scope.row.License }}</span>
                </div>
                <div>
                  工程：
                  <span class="table-value">{{ scope.row.ProjectName }}</span>
                </div>
                <div>
                  强度：
                  <span class="table-value">{{ scope.row.GradeName }}</span>
                  任务：
                  <span class="table-value">{{ scope.row.TaskCode }}</span>
                </div>
                <div>
                  备注：
                  <span class="table-value">{{ scope.row.Remark }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="Code" label="方量信息" width="300">
              <template slot-scope="scope">
                <div>
                  生产线:
                  <span class="table-value">
                    {{ scope.row.StationLineName }}
                  </span>
                </div>
                <div>
                  累计方量/车次：
                  <span class="table-value">
                    {{ scope.row.TaskTotalQuantity }}/{{
                      scope.row.TaskTotalTruckCount
                    }}
                  </span>
                </div>
                <div>
                  毛重：
                  <span class="table-value">{{ scope.row.GrossWeight }}</span>
                  皮重：
                  <span class="table-value">{{ scope.row.TareWeight }}</span>
                </div>
                <div>
                  扣重：
                  <span class="table-value">{{ scope.row.BuckleWeight }}</span>
                  净重：
                  <span class="table-value">{{ scope.row.NetWeight }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="130" fixed="right">
              <template slot-scope="scope">
                <el-link
                  type="danger"
                  size="mini"
                  @click="
                    () => {
                      sels.push(scope.row);
                      deleteWeighingOut();
                    }
                  "
                >
                  删除
                </el-link>
                <el-link
                  type="primary"
                  size="mini"
                  @click="
                    () => {
                      currentRow = scope.row;
                      handleEdit();
                    }
                  "
                >
                  修改
                </el-link>
                <el-link
                  type="info"
                  size="mini"
                  @click="
                    () => {
                      print(scope.row.Id);
                    }
                  "
                >
                  打印
                </el-link>
                <el-link
                  type="info"
                  size="mini"
                  @click="
                    () => {
                      printOutmaster(scope.row.ProudOutMasterID);
                    }
                  "
                >
                  打印出货单
                </el-link>
                <el-link
                  type="success"
                  size="mini"
                  @click="
                    () => {
                      currentRow = scope.row;
                      handleComplete();
                    }
                  "
                >
                  完成
                </el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
//引入whsetting.js的所有export的对象,并起别名为api,通过api.***访问成员
import { BaseApiUrl } from "../../api/api";
import * as api from "../../api/weighingOut";
import { getPrintContent } from "../../api/prodoutmaster";
import { getVehicleListPage } from "../../api/vehicle";
import printJS from "print-js";
//import {getWeight} from "../../api/wcf";
import originJSONP from "jsonp";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { runReport } from "../../api/viewReport";
export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [], //按钮列表
      whsettingListSelect: [], //磅秤列表
      whsettingListTop: [], //磅秤列表
      whsettingTopId: "",
      whsetting: {}, //当前选择磅秤
      VideoUrlList: [], //当前视频地址
      socket: [],
      editFormRules: {
        // MatName: [
        //   { required: true, message: "请输入物资名称", trigger: "blur" },
        // ],
      },
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      editForm: {
        GrossWeight: 0,
        TareWeight: 0,
        NetWeight: 0,
        Status: 0,
        WeightType: 0,
        TaskTotalQuantity: 0,
        WeighingQuantity: 0,
      }, //编辑数据
      WeighingOut: [], //过磅数据列表
      currentRow: {}, //当前选择列
      whnumber: 0,
      editLoading: false,
      isEdit: false,
      License: "", //查询车牌
      Status: -1, //查询出料过磅状态
      WeightID: "", //查询过磅磅秤ID
      weightOutAuto: null,
      outtime: 3000,
      loading: false,
      TarePrint: false, //是否过磅并打印
      proOutMasterList: [], //待过磅的出货单
      editVehicle: {}, //车辆过磅信息（只过皮重时）
      showType: true, //显示类型，默认显示过磅页面，false为显示车号选择过皮页面
      VehicleList: [], //所有车辆
      shotGList: [], //毛重拍照List
      shotTList: [], //皮重拍照片List
      lastLicense: "", //上一次车牌识别的车牌
      showPhotoBtn: false, //是否显示拍照按钮
      weightCameraInAuto: null, //摄像头识别线程
      weightSocket: null, //磅秤Socket对象
      cameraSocket: null, //车牌识别Socket对象
      weightTimeoutObj: null, //磅秤心跳检测包
      cameraTimeoutObj: null, //摄像头心跳检测包
      videoTimeoutObj: null, //视频心跳检测包
    };
  },
  computed: {},
  methods: {
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getWeighingOut();
    },
    handleEdit() {
      this.editForm = JSON.parse(JSON.stringify(this.currentRow));
      this.shotGList = [];
      this.shotTList = [];
      //this.editForm = this.currentRow;
      if (!!this.currentRow.ImageFilePathTare) {
        var UploadUrls = this.currentRow.ImageFilePathGross;
        let souceImgFile = JSON.parse(UploadUrls);
        souceImgFile.map((e) => {
          e.FilePath = BaseApiUrl + "/" + e.FilePath;
        });
        this.shotGList = souceImgFile;
      }
      if (!!this.currentRow.ImageFilePathTare) {
        var UploadUrls = this.currentRow.ImageFilePathTare;
        let souceImgFile = JSON.parse(UploadUrls);
        souceImgFile.map((e) => {
          e.FilePath = BaseApiUrl + "/" + e.FilePath;
        });
        this.shotTList = souceImgFile;
      }
      this.isEdit = true;
    },
    cancel() {
      this.isEdit = false;
      this.editForm = {
        GrossWeight: 0,
        TareWeight: 0,
        NetWeight: 0,
        Status: 0,
        WeightType: 0,
        TaskTotalQuantity: 0,
        WeighingQuantity: 0,
      };
      this.shotGList = [];
      this.shotTList = [];
    },
    deleteWeighingOut() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          //this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteWeighingOut(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.getWeighingOut();
          });
        })
        .catch(() => {})
        .finally(() => {
          //this.listLoading = false;
        });
    },
    //完成
    handleComplete() {
      this.editLoading = true;
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .completeWeighingOut(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getWeighingOut();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    print(Id) {
      let para = {
        id: Id,
        printId: this.whsetting.PrintID,
      };
      api.getPrintContent(para).then((res) => {
        if (res.data.success) {
          runReport(
            res.data.response.PrintEntity,
            res.data.response.PrintModel
          );
          let syles = "";
          if (document.styleSheets.length > 1) {
            for (let i = document.styleSheets.length - 1; i >= 0; i--) {
              if (document.styleSheets[i].ownerNode.id.indexOf("gridcss") > 0) {
                let rulesList = document.styleSheets[i].cssRules;
                for (let j = 0; j < rulesList.length; j++) {
                  syles += rulesList[j].cssText;
                }
                break;
              }
            }
          }
          printJS({
            printable: "report_holder",
            type: "html",
            header: null,
            targetStyles: ["*"],
            style: syles,
            scanStyles: false,
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.getWeighingOut();
      });
    },
    printOutmaster(id) {
      let para = {
        id: id,
      };
      getPrintContent(para).then((res) => {
        this.listLoading = false;
        if (res.data.success) {
          runReport(
            res.data.response.PrintEntity,
            res.data.response.PrintModel
          );
          let syles = "";
          if (document.styleSheets.length > 1) {
            for (let i = document.styleSheets.length - 1; i >= 0; i--) {
              if (document.styleSheets[i].ownerNode.id.indexOf("gridcss") > 0) {
                let rulesList = document.styleSheets[i].cssRules;
                for (let j = 0; j < rulesList.length; j++) {
                  syles += rulesList[j].cssText;
                }
                break;
              }
            }
          }
          printJS({
            printable: "report_holder",
            type: "html",
            header: null,
            targetStyles: ["*"],
            style: syles,
            scanStyles: false,
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    changePrint() {
      window.localStorage.WhOut1TarePrint = this.TarePrint;
    },
    //获取过磅列表
    getWeighingOut(optype) {
      if (optype == 1) {
        this.page = 1;
      }
      let para = {
        page: this.page,
        license: this.License,
        status: this.Status,
        weightID: this.WeightID,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getWeighingOutListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.WeighingOut = res.data.response.data;
        this.listLoading = false;
        this.currentRow = null;
        this.sels = [];
      });
    },
    //获取磅秤列表
    getWhsettingDetail() {
      let para = {
        key: 100,
      };
      this.listLoading = true;
      api.getWhsettingDetail(para).then((res) => {
        if (res.data.response && res.data.response.length > 0) {
          this.whsettingListSelect = res.data.response;
          this.whsettingListTop = res.data.response;
          if (window.localStorage.WhOut1Com) {
            this.whsetting = JSON.parse(window.localStorage.WhOut1Com);
            this.whsettingTopId = this.whsetting.Id;
          } else {
            this.whsetting = res.data.response[0];
            this.whsettingTopId = res.data.response[0].Id;
          }
          if (
            this.whsetting.VideoUrl != "" &&
            this.whsetting.VideoUrl != null
          ) {
            this.VideoUrlList = this.whsetting.VideoUrl.split(",");
          } else {
            this.VideoUrlList = [];
          }
          this.initSocket(-1);
          if (this.whsetting.CameraUrl && this.whsetting.Cameras) {
            this.getCamera();
          }
          if (this.whsetting.Photos && this.whsetting.CameraUrl) {
            this.showPhotoBtn = true;
          } else {
            this.showPhotoBtn = false;
          }
          this.getweight();
        }
      });
    },
    selectWhsetting(id) {
      this.whsetting = this.whsettingListTop.filter((e) => e.Id == id)[0];
      window.localStorage.WhOut1Com = JSON.stringify(this.whsetting);
      if (this.whsetting.VideoUrl != "" && this.whsetting.VideoUrl != null) {
        this.VideoUrlList = this.whsetting.VideoUrl.split(",");
        this.initSocket(-1);
      } else {
        this.VideoUrlList = [];
      }

      if (this.whsetting.Photos && this.whsetting.CameraUrl) {
        this.showPhotoBtn = true;
      } else {
        this.showPhotoBtn = false;
      }
      this.getweight();
    },
    addGross() {
      this.editForm.GrossWeight = this.whnumber;
      this.getShot(0);
      this.NetWeightCount();
    },
    addTare() {
      this.editForm.TareWeight = this.whnumber;
      this.editVehicle.CarWeight = this.whnumber;
      if (this.whnumber > 0) {
        let vehicleID = this.showType
          ? this.editForm.VehicleID
          : this.editVehicle.Id;
        if (vehicleID && vehicleID > 0) {
          let vehicledM = {
            Id: vehicleID,
            CarWeight: this.whnumber,
          };
          let para = Object.assign({}, vehicledM);
          api
            .setWeight(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.VehicleList.map((v) => {
                  if (v.Id == vehicleID) {
                    v.CarWeight = this.whnumber;
                  }
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.editLoading = false;
            });
        }
      }
      this.getShot(1);
      this.NetWeightCount();
    },
    saveForm() {
      this.editForm.WeightID = this.whsetting.Id;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          let para = Object.assign({}, this.editForm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          if (this.isEdit) {
            api
              .editWeighingOut(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  if (this.TarePrint) {
                    this.print(this.editForm.Id);
                  }
                  this.cancel();
                  this.getWeighingOut();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.editLoading = false;
              });
          } else {
            api
              .addWeighingOut(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.cancel();
                  this.getWeighingOut();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.editLoading = false;
              });
          }
        }
      });
    },
    //计算净重
    NetWeightCount() {
      var grossWeight =
        this.editForm.GrossWeight == "" ||
        this.editForm.GrossWeight == undefined
          ? 0
          : Number(this.editForm.GrossWeight);
      var tareWeight =
        this.editForm.TareWeight == "" || this.editForm.TareWeight == undefined
          ? 0
          : Number(this.editForm.TareWeight);
      var cubRate =
        this.editForm.DiscountCubRate == "" ||
        this.editForm.DiscountCubRate == undefined
          ? 0
          : Number(this.editForm.DiscountCubRate);

      var buckleWeight =
        this.editForm.BuckleWeight == "" ||
        this.editForm.BuckleWeight == undefined
          ? 0
          : Number(this.editForm.BuckleWeight); //扣重1 扣重(kg)
      var deductionRate =
        this.editForm.DeductionRate == "" ||
        this.editForm.DeductionRate == undefined
          ? 0
          : Number(this.editForm.DeductionRate); //扣重2 扣重(%)
      var deductWeight2 = ((grossWeight * deductionRate) / 100).toFixed(0);
      this.editForm.NetWeight = Number(
        grossWeight - tareWeight - buckleWeight - deductWeight2
      ).toFixed(2);
      if (this.editForm.DiscountCubRate > 0 && cubRate > 0) {
        this.editForm.WeighingQuantity = (
          Number(this.editForm.NetWeight) / cubRate
        ).toFixed(2);
      }
    },
    getweight() {
      if (this.whsetting.WeightSocketUrl) {
        this.weightSocketInit();
        return;
      }
      if (this.weightOutAuto) {
        clearTimeout(this.weightOutAuto);
      }
      let that = this;
      if (that && !that._isDestroyed) {
        try {
          let opts = { timeout: 3000 };
          originJSONP(this.whsetting.WcfUrl, opts, (err, data) => {
            if (data && data.length > 0 && data[0].Weight > 0) {
              //如果原先是伪休眠状态,则需要重开任务,以200ms的速度运行
              if (this.outtime === 3000) {
                this.outtime = 200;
              }
              this.whnumber = data[0].Weight;
            } else {
              if (this.outtime !== 3000) {
                this.outtime = 3000;
              }
              this.whnumber = 0;
            }
            this.weightOutAuto = setTimeout(() => {
              this.getweight();
            }, this.outtime);
          });
        } catch {
          this.outtime = 3000;
          this.weightOutAuto = setTimeout(() => {
            this.getweight();
          }, this.outtime);
        }
      }
    },
    weightSocketInit() {
      let that = this;
      if (
        this.weightSocket != undefined &&
        this.weightSocket &&
        this.weightSocket.readyState < 2
      ) {
        console.log("磅秤被主动关闭...");
        this.weightSocket.close();
      }
      this.weightTimeOutObjFunc();
      //链接服务端
      this.weightSocket = new WebSocket(this.whsetting.WeightSocketUrl);
      //配置客户端连接成功的回调方法
      this.weightSocket.onopen = function (event) {
        console.log("磅秤打开中...");
      };
      //配置客户端处理消息的回调方法
      this.weightSocket.onmessage = function (event) {
        if (that && !that._isDestroyed) {
          if (that.isJSON(event.data)) {
            var data = JSON.parse(event.data);
            if (data && data.Weight > 0) {
              that.whnumber = data.Weight;
            } else {
              that.whnumber = 0;
            }
          } else {
            that.whnumber = 0;
          }
        } else {
          that.whnumber = 0;
          that.weightSocket.close();
        }
      };
      this.weightSocket.onerror = function (event) {
        console.log("磅秤连接失败...");
      };
      this.weightSocket.onclose = function (event) {
        console.log("磅秤被服务端主动关闭...");
      };
    },
    weightTimeOutObjFunc() {
      if (this.weightTimeoutObj) {
        clearTimeout(this.weightTimeoutObj);
      }
      var that = this;
      //每二十秒检测一次Socket在线状态,在线则发送Send心跳包
      this.weightTimeoutObj = setTimeout(() => {
        if (that && !that._isDestroyed) {
          if (
            that.weightSocket != undefined &&
            that.weightSocket &&
            that.weightSocket.readyState != 3
          ) {
            //console.log("磅秤在线,发送检测包");
            try {
              that.weightSocket.send("ping");
            } catch {}
            //磅秤心跳检测包
            that.weightTimeOutObjFunc();
          } else {
            console.log("磅秤连接断开,重新初始化磅秤");
            that.weightSocketInit();
          }
        }
      }, 20000);
    },
    remoteMethod(query) {
      let para = {
        license: query,
      };
      api.getOutMasterHistry(para).then((res) => {
        if (res.data.response != null) {
          this.proOutMasterList = res.data.response.ProdOutMasterWhOutViewModel;
        }
      });
    },
    getOutMasterByLcense(obj) {
      let para = {
        license: obj,
      };
      api.getOutMasterHistry(para).then((res) => {
        if (
          res.data.response != null &&
          res.data.response.ProdOutMasterWhOutViewModel &&
          res.data.response.ProdOutMasterWhOutViewModel.length > 0
        ) {
          this.proOutMasterList = res.data.response.ProdOutMasterWhOutViewModel;
          var prodOutMasterItem = this.proOutMasterList[0];
          this.editForm.TaskCode = prodOutMasterItem.TaskCode;
          this.editForm.TaskID = prodOutMasterItem.TaskID;
          this.editForm.ProudOutMasterID = prodOutMasterItem.Id;
          this.editForm.ProdOutMasterCode = prodOutMasterItem.Code;
          this.editForm.VehicleErpCode = prodOutMasterItem.VehicleErpCode;
          this.editForm.VehicleID = prodOutMasterItem.VehicleID;
          this.editForm.License = prodOutMasterItem.License;
          this.editForm.TaskTotalQuantity = prodOutMasterItem.TaskTotalQuantity;
          this.editForm.TaskTotalTruckCount =
            prodOutMasterItem.TaskTotalTruckCount + 1;
          this.editForm.VehiclesTotal = prodOutMasterItem.VehiclesTotal;
          this.editForm.QuantityTotal = prodOutMasterItem.QuantityTotal;
          this.editForm.TareWeight = prodOutMasterItem.CarWeight;
          this.editForm.DiscountCubRate = prodOutMasterItem.Weight;
          this.editForm.Quantity = prodOutMasterItem.Quantity;
          this.editForm.ProjectPart = prodOutMasterItem.ProjectPart;
          this.editForm.GradeID = prodOutMasterItem.GradeID;
          this.editForm.GradeName = prodOutMasterItem.GradeName;
          this.editForm.ProjectID = prodOutMasterItem.ProjectID;
          this.editForm.ProjectName = prodOutMasterItem.ProjectName;
          this.editForm.StationLineID = prodOutMasterItem.StationLineID;
          this.editForm.StationLineName = prodOutMasterItem.StationLineName;
          this.NetWeightCount();
        }
      });
    },
    changeLicense(obj) {
      var prodOutMasterItem = this.proOutMasterList.filter(
        (e) => e.Id == obj
      )[0];
      this.editForm.TaskCode = prodOutMasterItem.TaskCode;
      this.editForm.TaskID = prodOutMasterItem.TaskID;
      this.editForm.ProudOutMasterID = prodOutMasterItem.Id;
      this.editForm.ProdOutMasterCode = prodOutMasterItem.Code;
      this.editForm.VehicleErpCode = prodOutMasterItem.VehicleErpCode;
      this.editForm.VehicleID = prodOutMasterItem.VehicleID;
      this.editForm.License = prodOutMasterItem.License;
      this.editForm.TaskTotalQuantity = prodOutMasterItem.TaskTotalQuantity;
      this.editForm.TaskTotalTruckCount =
        prodOutMasterItem.TaskTotalTruckCount + 1;
      this.editForm.VehiclesTotal = prodOutMasterItem.VehiclesTotal;
      this.editForm.QuantityTotal = prodOutMasterItem.QuantityTotal;
      this.editForm.TareWeight = prodOutMasterItem.CarWeight;
      this.editForm.DiscountCubRate = prodOutMasterItem.Weight;
      this.editForm.Quantity = prodOutMasterItem.Quantity;
      this.editForm.ProjectPart = prodOutMasterItem.ProjectPart;
      this.editForm.GradeID = prodOutMasterItem.GradeID;
      this.editForm.GradeName = prodOutMasterItem.GradeName;
      this.editForm.ProjectID = prodOutMasterItem.ProjectID;
      this.editForm.ProjectName = prodOutMasterItem.ProjectName;
      this.editForm.StationLineID = prodOutMasterItem.StationLineID;
      this.editForm.StationLineName = prodOutMasterItem.StationLineName;
      this.NetWeightCount();
    },
    showTypeChange() {
      this.showType = !this.showType;
    },
    getVehicleList() {
      let para = {
        page: 1,
        intPageSize: 999,
      };
      this.listLoading = true;
      getVehicleListPage(para).then((res) => {
        this.VehicleList = res.data.response.data;
      });
    },
    selectVehicle(obj) {
      let carWeight = this.VehicleList.filter((e) => e.Id == obj)[0].CarWeight;
      this.editVehicle.CarWeight = carWeight;
    },
    //摄像头识别车牌初始化
    getCamera() {
      if (this.whsetting.CameraSocketUrl) {
        this.cameraSocketInit();
        return;
      }
      if (this.weightCameraInAuto) {
        clearTimeout(this.weightCameraInAuto);
      }
      let that = this;
      if (that && !that._isDestroyed) {
        try {
          originJSONP(
            this.whsetting.CameraUrl +
              "/License?cameraIDList=" +
              this.whsetting.Cameras,
            null,
            (err, data) => {
              if (data && data.length > 0) {
                //for (var i = 0; i < data.length; i++) {
                if (data[0].License && this.lastLicense != data[0].License) {
                  this.lastLicense = data[0].License;
                  this.getOutMasterByLcense(data[0].License);
                }
              }
              //}
              this.weightCameraInAuto = setTimeout(() => {
                this.getCamera();
              }, 3000);
            }
          );
        } catch {
          this.weightCameraInAuto = setTimeout(() => {
            this.getCamera();
          }, 3000);
        }
      }
    },
    cameraSocketInit() {
      let that = this;
      if (
        this.cameraSocket != undefined &&
        this.cameraSocket &&
        this.cameraSocket.readyState < 2
      ) {
        console.log("摄像头被主动关闭...");
        this.cameraSocket.close();
      }
      this.cameraTimeOutObjFunc();
      //链接服务端
      this.cameraSocket = new WebSocket(this.whsetting.CameraSocketUrl);
      //配置客户端连接成功的回调方法
      this.cameraSocket.onopen = function (event) {
        console.log("摄像头打开中...");
      };
      //配置客户端处理消息的回调方法
      this.cameraSocket.onmessage = function (event) {
        if (that && !that._isDestroyed) {
          if (that.isJSON(event.data)) {
            var data = JSON.parse(event.data);
            if (data && data.License) {
              if (data.License && that.lastLicense != data.License) {
                that.lastLicense = data.License;
                that.getOutMasterByLcense(data.License);
              }
            }
          }
        } else {
          that.cameraSocket.close();
        }
      };
      this.cameraSocket.onerror = function (event) {
        console.log("摄像头连接失败...");
      };
      this.cameraSocket.onclose = function (event) {
        console.log("摄像头被服务端关闭...");
      };
    },
    cameraTimeOutObjFunc() {
      if (this.cameraTimeoutObj) {
        clearTimeout(this.cameraTimeoutObj);
      }
      var that = this;
      //每二十秒检测一次Socket在线状态,在线则发送Send心跳包
      this.cameraTimeoutObj = setTimeout(() => {
        if (that && !that._isDestroyed) {
          //摄像头心跳检测包
          if (
            that.cameraSocket != undefined &&
            that.cameraSocket &&
            that.cameraSocket.readyState != 3
          ) {
            //console.log("摄像头在线,发送检测包");
            try {
              that.cameraSocket.send("ping");
            } catch {}
            that.cameraTimeOutObjFunc();
          } else {
            console.log("摄像头连接断开,重新初始化摄像头");
            that.cameraSocketInit();
          }
        }
      }, 20000);
    },
    //拍照
    //whtype:0过毛，1 过皮
    getShot(whType) {
      var opts = { timeout: 6000 };
      if (this.whsetting.Photos && this.whsetting.CameraUrl) {
        this.editLoading = true;
        originJSONP(
          this.whsetting.CameraUrl +
            "/Shot?cameraIDList=" +
            this.whsetting.Photos,
          opts,
          (err, data) => {
            this.editLoading = false;
            if (data && data.length > 0) {
              if (whType == 0) {
                this.shotGList = [];
              } else {
                this.shotTList = [];
              }
              if (whType == 0) {
                this.editForm.ImageFilePathGross = JSON.stringify(data);
              } else {
                this.editForm.ImageFilePathTare = JSON.stringify(data);
              }
              data.map((e) => {
                e.FilePath = BaseApiUrl + "/" + e.FilePath;
                if (whType == 0) {
                  this.shotGList.push(e);
                } else {
                  this.shotTList.push(e);
                }
              });
            }
          }
        );
      }
    },
    //视频初始化
    initSocket(indexNum) {
      var that = this;
      this.videoTimeOutObjFunc();
      if (indexNum < 0) {
        this.destroyed();
        for (var i = 0; i < this.VideoUrlList.length; i++) {
          //链接服务端
          this.socket[i] = new WebSocket(this.VideoUrlList[i]);
          this.socket[i].Id = i;
          //配置客户端连接成功的回调方法
          this.socket[i].onopen = function (event) {
            console.log("open...");
          };
          var message = "";
          //配置客户端处理消息的回调方法
          this.socket[i].onmessage = function (event) {
            // //创建FileReader对象，该对象时html5中的特有对象，详细用法可以//参照html5相关资料
            // var reader = new FileReader();
            // var index = event.currentTarget.Id;
            // //设置FileReader对象的读取文件回调方法
            // reader.onload = function (eve) {
            //   //判断文件是否读取完成
            //   if (eve.target.readyState == FileReader.DONE) {
            //     //读取文件完成后，创建img标签来显示服务端传来的字节数//组
            //     var img = document.getElementById("video_" + index);
            //     //读取文件完成后内容放在this===当前
            //     //fileReader对象的result属性中，将该内容赋值img标签//浏览器就可以自动解析内容格式并且渲染在浏览器中
            //     img.src = this.result;
            //     //将标签添加到id为show的div中否则，即便是有img也看不见
            //     // document.getElementById("show") = img;
            //   }
            // };
            // //调用FileReader的readAsDataURL的方法自动就会触发onload事件
            // reader.readAsDataURL(event.data);
            //新方法
            var index = event.currentTarget.Id;
            if (event.data === "start!!!") {
              message = "";
            } else if (event.data === "end!!!") {
              if (that.isJSON(message)) {
                var obj = JSON.parse(message);
                if (obj.type == 0) {
                  var img = document.getElementById("video_" + index);
                  //读取文件完成后内容放在 this===当前
                  //fileReader 对象的 result 属性中，将该内容赋值 img 标签//浏览器就可以自动解析内容格式并且渲染在浏览器中
                  if (obj.jpegstream && img && img.src) {
                    img.src = "data:image/jpg;base64," + obj.jpegstream;
                  }
                } else if (obj.type == 1) {
                  //prase_data(JSON.parse(message), 0);-+

                  message = "";
                  //var obj=JSON.parse(message);
                  //img_2.src = 'data:image/jpg;base64,' + obj.reco_result.full_image;
                }
              }
            } else {
              message += event.data;
            }
          };
          this.socket[i].onerror = function (event) {
            var index = event.currentTarget.Id;
            console.log("Videoerror...");
          };
          this.socket[i].onclose = function (event) {
            var index = event.currentTarget.Id;
            console.log("close...");
          };
        }
      } else {
        //链接服务端
        this.socket[indexNum] = new WebSocket(this.VideoUrlList[i]);
        this.socket[indexNum].Id = indexNum;
        //配置客户端连接成功的回调方法
        this.socket[indexNum].onopen = function (event) {
          console.log("open...");
        };
        var message = "";
        //配置客户端处理消息的回调方法
        this.socket[indexNum].onmessage = function (event) {
          // //创建FileReader对象，该对象时html5中的特有对象，详细用法可以//参照html5相关资料
          // var reader = new FileReader();
          // var index = event.currentTarget.Id;
          // //设置FileReader对象的读取文件回调方法
          // reader.onload = function (eve) {
          //   //判断文件是否读取完成
          //   if (eve.target.readyState == FileReader.DONE) {
          //     //读取文件完成后，创建img标签来显示服务端传来的字节数//组
          //     var img = document.getElementById("video_" + index);
          //     //读取文件完成后内容放在this===当前
          //     //fileReader对象的result属性中，将该内容赋值img标签//浏览器就可以自动解析内容格式并且渲染在浏览器中
          //     img.src = this.result;
          //     //将标签添加到id为show的div中否则，即便是有img也看不见
          //     // document.getElementById("show") = img;
          //   }
          // };
          // //调用FileReader的readAsDataURL的方法自动就会触发onload事件
          // reader.readAsDataURL(event.data);
          //新方法
          var index = event.currentTarget.Id;
          if (event.data === "start!!!") {
            message = "";
          } else if (event.data === "end!!!") {
            if (that.isJSON(message)) {
              var obj = JSON.parse(message);
              if (obj.type == 0) {
                var img = document.getElementById("video_" + index);
                //读取文件完成后内容放在 this===当前
                //fileReader 对象的 result 属性中，将该内容赋值 img 标签//浏览器就可以自动解析内容格式并且渲染在浏览器中
                if (obj.jpegstream && img && img.src) {
                  img.src = "data:image/jpg;base64," + obj.jpegstream;
                }
              } else if (obj.type == 1) {
                //prase_data(JSON.parse(message), 0);
                message = "";
                //var obj=JSON.parse(message);
                //img_2.src = 'data:image/jpg;base64,' + obj.reco_result.full_image;
              }
            }
          } else {
            message += event.data;
          }
        };
        this.socket[indexNum].onerror = function (event) {
          var index = event.currentTarget.Id;
          console.log("Videoerror...");
        };
        this.socket[indexNum].onclose = function (event) {
          var index = event.currentTarget.Id;
          console.log("close...");
        };
      }
    },
    //Socket释放
    destroyed() {
      // 销毁监听
      this.socket.map((e) => {
        if (e != undefined && e && e.readyState < 2) {
          e.close();
        }
      });
    },
    videoTimeOutObjFunc() {
      if (this.videoTimeoutObj) {
        clearTimeout(this.videoTimeoutObj);
      }
      var that = this;
      //每二十秒检测一次Socket在线状态,在线则发送Send心跳包
      this.videoTimeoutObj = setTimeout(() => {
        if (that && !that._isDestroyed) {
          that.videoTimeOutObjFunc();
          that.socket.map((item, index) => {
            //视频心跳检测包
            if (item != undefined && item && item.readyState != 3) {
              //console.log("视频在线,发送检测包");
              try {
                item.send("ping");
              } catch {}
            } else {
              console.log("视频连接断开,重新初始化视频");
              that.initSocket(index);
            }
          });
        }
      }, 30000);
    },
    isJSON(str) {
      if (typeof str == "string") {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getWhsettingDetail();
    this.getWeighingOut();
    this.getVehicleList();
    //默认是否过皮并打印
    if (
      window.localStorage.WhOut1TarePrint &&
      window.localStorage.WhOut1TarePrint == "true"
    ) {
      this.TarePrint = true;
    }
  },
};
</script>

<style scoped>
.flex-row {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.flex-row.between {
  justify-content: space-between;
}
.flex-row.wrap {
  flex-wrap: wrap;
}

.editForm .el-select {
  width: 100%;
}

.number {
  height: 100px;
  width: 80%;
  line-height: 100px;
  text-align: center;
  font-size: 5rem;
  background: rgb(247, 244, 229);
  border: 2px solid rgb(191, 169, 46);
  margin: 20px auto;
}
.overflow-auto {
  height: 55vh;
  overflow-y: scroll;
}
.rigth-card {
  margin-top: 10px;
}

.rigth-card /deep/.el-card__body {
  padding: 5px !important;
}
.rigth-card:nth-of-type(2n) {
  margin-left: 20px;
}
.weigth {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}
.weigth > div {
  width: 25%;
  font-size: 14px;
  padding: 4px;
  margin: 0 1px;
  text-align: center;
  box-shadow: 0 0 15px -6px;
}

.weigth > div:nth-of-type(1) {
  color: #67c23a;
}
.weigth > div:nth-of-type(2) {
  color: #409eff;
}
.weigth > div:nth-of-type(3) {
  color: #f56c6c;
}

.weigth > div > div:first-of-type {
  margin-bottom: 5px;
}
.rigth-card .el-form-item {
  margin-bottom: 0;
}
</style>
